import React from 'react';
import Carousel from 'react-material-ui-carousel';
import useEntries from '../Common/useEntries';
import Event from '../Events/Events';
import { isNewsItem } from '../Events/eventFilters';
import { LoadingState } from '../Common/PageLayout';

/** Homepage carousel of the five most recent news items. */
export default function Slider() {
    const { items, loading } = useEntries({
        content_type: 'events',
        order: '-sys.createdAt',
        limit: 20,
    });

    const featured = items.filter(isNewsItem).slice(0, 5);

    if (loading) return <LoadingState label="Loading featured news" />;
    if (featured.length === 0) return null;

    return (
        <Carousel
            animation="slide"
            navButtonsAlwaysInvisible={featured.length < 2}
            indicators={featured.length > 1}
            autoPlay
            interval={7000}
            navButtonsProps={{ style: { backgroundColor: '#0e2748', opacity: 0.85 } }}
            indicatorIconButtonProps={{ style: { color: '#cbd5e1' } }}
            activeIndicatorIconButtonProps={{ style: { color: '#225491' } }}
        >
            {featured.map((entry) => (
                <Event key={entry.sys.id} events={entry} variant="slider" />
            ))}
        </Carousel>
    );
}
